// Once an unpaid trial expires the server rejects disallowed writes with 403 {code: 'read_only'}.
// The backend owns the allowlist so newly added recovery and access-management paths cannot be
// blocked by stale client routing rules.
export const READ_ONLY_ERROR_CODE = 'read_only'
export const READ_ONLY_MESSAGE = 'Read-only — subscribe to edit'

export const isReadOnlyError = (error: unknown) => {
    const response = (error as { response?: { status?: number; data?: { code?: string } } } | null)?.response
    return response?.status === 403 && response.data?.code === READ_ONLY_ERROR_CODE
}

// The app shell subscribes to toast and refetch user_info; utils can't reach the query client.
type TReadOnlyListener = () => void
const listeners = new Set<TReadOnlyListener>()
let pendingRejectedWrites = 0
export const onReadOnlyRejection = (listener: TReadOnlyListener) => {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}
export const notifyReadOnlyRejection = () => listeners.forEach((listener) => listener())

// API wrappers often replace Axios errors with action-specific strings. Keep a one-shot marker per
// rejected write so the shared mutation handler can avoid a duplicate generic error toast without
// hiding failures from allowed billing, account, settings, or feedback requests.
export const markReadOnlyWriteRejected = () => {
    pendingRejectedWrites += 1
    notifyReadOnlyRejection()
}
export const consumeReadOnlyWriteRejection = () => {
    if (pendingRejectedWrites === 0) return false
    pendingRejectedWrites -= 1
    return true
}
